import React, { Component } from 'react';
import Box from '../../hoc/Box/Box';
import Equipment from '../../containers/Equipment/Equipment';
import Error from '../../components/UI/Error/Error';
import InnerToolBar from '../InnerToolBar/InnerToolbar';
import Modal from '../../components/UI/Modal/Modal';
import NetworkInfo from '../../containers/NetworkInfo/NetworkInfo';
import NetworkThread from '../../containers/NetworkThread/NetworkThread'
import ProgressBar from '../UI/ProgressBar/ProgressBar';
import Spinner from '../../components/UI/Spinner/Spinner';
import Success from '../../components/UI/Success/Success';
import SwitchAccountsForm from './SwitchAccountsForm/SwitchAccountsForm';
import Toolbar from '../../components/Toolbar/Toolbar';
import classes from './Layout.css';
import packageJson from '../../../package.json';
import { FaSync } from 'react-icons/fa';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import ErrorAlert from '../../shared/Alert/ErrorAlert';
class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      error: false,
      success: false,
      showingTimeRemaining: false,
      clickCount: 1,
      showing: true,
      refreshButtonClickedOnEquipment: false,
      redirectPage: true,
      showSideMenuFromSpecReady: null,
      featureFlags: sessionStorage.getItem('featureFlags'),
      showTooltip: false,
      showSidePanelMobile: false
    };
  }
  componentDidMount() {
    this.props.onInitSettings();
    this.props.onInitWan();
    this.props.onInitBroadcastSettings();
    this.props.onInitStaticIPConfig();
    this.props.onInitTenant();
    this.props.onInitManaged();
    this.props.onInitLogs();
    this.props.onInitDevices();
    this.props.onInitBandwidth();
    this.props.onInitDhcp();
    this.props.onInitDns();
    this.props.onInitUpnp();
    this.props.onInitMobileHome();
    this.props.onInitSelectedEquipment();
    this.props.getEntitlement();
    this.props.onGetFirmwareUpdate();
    this.props.locateAllPods();
    this.props.onInitSecurityLogInfo();
    this.props.getSecondSsid();
    this.props.getAllWifiSecuritySummary();
    if (this.state.featureFlags.includes('speedTest')) {
      this.props.setRouterSpeedVisiblity(true);
    }
    if (sessionStorage.getItem("multi")) {
      // console.log('TRUEEE')
      this.props.getMultiRouter();
    }
    if (this.state.featureFlags.includes('advancedSpec') || true) {
      this.props.onAdvancedSecurityHandler({ method: 'GET' });
      let payload = { maxDaysOld: 1, pageNumber: 1, size: 10 };
      this.props.onGetAdvancedSecurityThreats(payload);
    }
    if (this.state.featureFlags.includes('speedBoost') ) {
      this.props.getSpeedBoostCheckDevices();
    }
    if (!sessionStorage.getItem('type')?.includes('Business')) {
      this.props.onInitDeviceGroups();
    }
    if (this.state.featureFlags.includes('secondSSID') ) {
      this.props.getSecondSsid();
    }
    // if (this.state.featureFlags.includes('Wpa')) {
    //   this.props.getAllWifiSecuritySummary();
    // }
  }
  componentWillUpdate() {
    if (this.state.showing && this.state.showSidePanelMobile) {
      this.setState({ showing: false });
    }
  }

  componentWillReceiveProps(nextProps, prevState) {
    if (!this.showSidePanelMobile && window.innerWidth <= 900 && nextProps && nextProps.realSettings && nextProps.realSettings['2ghz_wifi'] && nextProps.realSettings['2ghz_wifi'].subscriber &&
      this.props && this.props.realSettings && this.props.realSettings['2ghz_wifi'] && this.props.realSettings['2ghz_wifi'].subscriber &&
      (nextProps.realSettings['2ghz_wifi'].subscriber.ssid !== this.props.realSettings['2ghz_wifi'].subscriber.ssid
        || nextProps.realSettings['2ghz_wifi'].subscriber.passphrase !== this.props.realSettings['2ghz_wifi'].subscriber.passphrase
      )) {
      this.setState({
        showSidePanelMobile: true
      })
    }
  }
  componentDidUpdate() {
    // console.log('is showing', this.state.showing)
  }

  onOpenModal = () => {
    this.setState({
      modal: true,
    });
  };
  modalCancelHandler = () => {
    this.setState({
      modal: false,
    });
  };

  successErrorResetHandler = () => {
    this.setState({ error: false, success: false, modal: false });
    this.props.onResetEquipmentErrorSuccess();
  };
  TrippleClick = () => {
    this.setState({
      clickCount: this.state.clickCount + 1,
    });
    if (this.state.clickCount === 7) {
      this.props.onToggleIsDummy();
    }
    if (this.state.clickCount >= 8) {
      this.props.onToggleIsDummy();
    }
  };

  buildRouterTree(realWan, realEquipment, setEquipmentSelectionFn) {
    let router = {
      id: realWan.id,
      mac: realWan.mac,
      nickname: realWan.nickname,
      model: realWan.model,
      connectedDeviceCount: realWan.connectedDeviceCount,
      connectionState: realWan.connectionState,
      setEquipmentSelection: setEquipmentSelectionFn,
      pods: [],
      checkingWan: this.props.checkingWan,
    };

    if (realEquipment.claimedPods === undefined) {
      return router;
    }
    let claimedPods = realEquipment.claimedPods.map((claimedPod) => {
      return {
        id: claimedPod.id,
        mac: claimedPod.mac,
        nickname: claimedPod.nickname,
        defaultName: claimedPod.defaultName,
        model: claimedPod.model,
        serialNumber: claimedPod.serialNumber,
        connectedDeviceCount: claimedPod.connectedDeviceCount,
        connectionState: claimedPod.connectionState,
        claimed: true,
        setEquipmentSelection: setEquipmentSelectionFn,
        routerId: router.id,
        ip: claimedPod.ip,
        freqBand:
          claimedPod.backHaul && claimedPod.backHaul.metadata
            ? claimedPod.backHaul.metadata.freqBand
            : ' ',
        pods: [],
        checkingWan: this.props.checkingWan,
        podTimer: this.props.podTimer,
      };
    });
    claimedPods.push(router);

    let claimedPodMap = claimedPods.reduce((acc, cpod) => {
      acc[cpod.id] = cpod;
      return acc;
    }, {});
    this.props.realEquipment.claimedPods.forEach((cpod) => {
      let claimedPod = claimedPodMap[cpod.id];
      let parent;
      if (cpod.leafToRoot === undefined || cpod.leafToRoot.length === 0) {
        parent = router;
      } else {
        parent = claimedPodMap[cpod.leafToRoot[0].id];
      }

      if (parent !== undefined) {
        parent.pods.push(claimedPod);
      }
    });
    return router;
  }

  getUnclaimedPods(realEquipment, setEquipmentSelectionFn) {
    if (realEquipment === undefined) {
      return [];
    }
    if (realEquipment.pods === undefined) {
      return [];
    }
    if (realEquipment.claimedPods === undefined) {
      return [];
    }
    let claimedPodsMap = realEquipment.claimedPods.reduce((acc, cpod) => {
      if (cpod.id) acc[cpod.id.toLowerCase()] = cpod;
      if (cpod.serialNumber) acc[cpod.serialNumber.toLowerCase()] = cpod;
      return acc;
    }, {});
    let unclaimedPods = realEquipment.pods.filter((pod) => {
      const podMac = pod.macAddress || (pod.componentList && pod.componentList[0] ? pod.componentList[0].macAddress : null);
      const serial = (pod.serialNumber || '').toLowerCase();
      const mac = (podMac || '').toLowerCase();
      return claimedPodsMap[serial] === undefined && claimedPodsMap[mac] === undefined;
    });
    unclaimedPods = unclaimedPods.map((pod) => {
      return {
        id: pod.serialNumber,
        model: pod.vendorModel,
        make: pod.make,
        macAddress: pod.macAddress || (pod.componentList && pod.componentList[0] ? pod.componentList[0].macAddress : null),
        claimed: false,
        setEquipmentSelection: setEquipmentSelectionFn,
      };
    });
    return unclaimedPods;
  }

  getModems(realEquipment) {
    if (realEquipment === undefined) {
      return [];
    }
    if (realEquipment.modems === undefined) {
      return [];
    }

    let modems = realEquipment.modems.map((modem) => {
      return {
        id: modem.serialNumber,
        model: modem.typeDescription
          ? modem.typeDescription
          : modem.description,
        make: modem.make,
      };
    });
    return modems;
  }

  prepareNetworkEquipmentData() {
    if (!this.props.realEquipment || this.props.realEquipment === null) {
      return undefined;
    }

    let router = this.buildRouterTree(
      this.props.realWan,
      this.props.realEquipment,
      this.setEquipmentSelection
    );
    let unclaimedPods = this.getUnclaimedPods(
      this.props.realEquipment,
      this.setEquipmentSelection
    );
    let modems = this.getModems(this.props.realEquipment);

    let customerNetwork = {
      routers: [router],
      unclaimedPods: unclaimedPods,
      modems: modems,
      setEquipmentSelection: this.setEquipmentSelection,
      selectedEquipment: this.props.selectedEquipment,
    };

    let equipment = {
      customerNetwork: customerNetwork,
    };
    return equipment;
  }

  setEquipmentSelection = (equipment) => {
    if (equipment.didClick) {
      this.props.onSetSelectedEquipment(equipment);
    }
    this.setState({ redirectPage: true });
    this.setState({ showing: true });
  };
  showSideMenuSpecReady = () => {
    this.setState({
      showSideMenuFromSpecReady: true,
      showing: false,
    });
    setTimeout(() => {
      this.setState({
        showSideMenuFromSpecReady: null,
      });
      this.props.onDontShowSideMenu();
    }, 1);
  };

  render() {
    const { showing } = this.state;

    if (this.props.error && !this.state.error) {
      this.setState({ error: true, success: false, modal: false });
      this.props.onResetEquipmentErrorSuccess();

    }
    if (this.props.success && !this.state.success) {
      this.setState({ error: false, success: true, modal: false });
      this.props.onResetEquipmentErrorSuccess();

    }
    let progressBar;

    if (this.props.showTimeRemaining && !this.state.showingTimeRemaining) {
      this.setState({
        showingTimeRemaining: true,
      });
    } else if (
      !this.props.showTimeRemaining &&
      this.state.showingTimeRemaining
    ) {
      this.setState({
        showingTimeRemaining: false,
      });
    }
    if (this.state.showingTimeRemaining) {
      progressBar = (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            height: 50,
            backgroundColor: 'white',
            boxShadow: '0px -5px 5px lightgray',
            zIndex: 100000,
          }}
        >
          <ProgressBar />
        </div>
      );
    } else {
      progressBar = <div />;
    }
    let sideDrawerComponent;
    let networkInfo;

    const showSpinner = (this.props.settingsLoading ||
      !this.props.settingsLoaded ||
      this.props.wanLoading ||
      !this.props.wanLoaded);

    if (showSpinner && window.innerWidth > 700) {
      sideDrawerComponent = <Spinner />;
    } else if (!this.props.realSettings || !this.props.realWan) {
      sideDrawerComponent = (
        <>
          <div id = 'NetworkInfoTxt' style={{ color: 'gray', display: 'flex', flexDirection: 'column' }}>
            Something went wrong. There is limited network information available at this time.
            {/* <ErrorAlert /> */}
            </div>
        </>
      );
    } else {

      networkInfo = (
        <NetworkInfo
          originalName={this.props.realSettings['2ghz_wifi'].subscriber.ssid}
          originalPassword={
            this.props.realSettings['2ghz_wifi'].subscriber.passphrase
          }
        />
      );

        
      let networkThread;
      if(sessionStorage.getItem("userRoles")?.includes("threadNetwork") && sessionStorage.getItem("type")?.includes("Spectrum WiFi") && sessionStorage.getItem("vendorModel")?.includes("SAX2V1R") && !this.props.threadInitialLoadFailed){
      if(false){
        networkThread = <Spinner />;
      }else{
        networkThread = <NetworkThread setEquipmentSelection={this.setEquipmentSelection} />
      }
    }
      let equipmentComponent;

      if (this.props.equipmentLoading) {
        equipmentComponent = <Spinner />;
      } else if (this.props.realEquipment) {
        let equipmentData = this.prepareNetworkEquipmentData();

        equipmentComponent = (
          <Equipment
            data={equipmentData}
            rEquip={this.props.realEquipment}
            refreshButtonClickedOnEquipment={
              this.state.refreshButtonClickedOnEquipment
            }
            refreshButtonClicked={(value) => {
              this.setState({ refreshButtonClickedOnEquipment: value });
            }}
          />
        );
      } else {
        equipmentComponent = (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'baseline',
            }}
          >
            <div style={{ color: 'gray', padding: 5 }}>
              There is no Equipment Information available at this time
            </div>
            <FaSync
              style={{ color: '#0073d1' }}
              onClick={() => {
                this.props.onInitEquipment();
              }}
            />
          </div>
        );
      }
      let toggleMenu, toggleInput;

      if (this.state.redirectPage && this.state.showing) {
        if (
          this.state.showSideMenuFromSpecReady === null &&
          this.props.showSideMenu === true
        ) {
          this.showSideMenuSpecReady();
          toggleMenu = (
            <label
              onClick={() => {
                this.setState({ showing: !showing });
              }}
              className={
                showing ? classes.toggleMenuLabel : classes.toggleMenuLabel1
              }
              for="css-toggle-menu"
              id="css-toggle-menu"
            ></label>
          );
          toggleInput = (
            <input
              aria-label={"Toggle Menu"}
              type="checkbox"
              className={classes.toggleMenu}
              id="css-toggle-menu"
              name="css-toggle-menu"
            />
          );
        } else {
          toggleMenu = (
            <label
              onClick={() => {
                this.setState({ showing: !showing });
              }}
              className={classes.toggleMenuLabel}
              for="css-toggle-menu"
              id="css-toggle-menu"
            ></label>
          );
        }
      } else {

        toggleMenu = (
          <label
            onClick={() => {
              this.setState({ showing: !showing });
            }}
            className={
              showing ? classes.toggleMenuLabel : classes.toggleMenuLabel1
            }
            for="css-toggle-menu"
            id="css-toggle-menu"
          ></label>
        );
        toggleInput = (
          <input
            aria-label={"Toggle Menu"}
            type="checkbox"
            className={classes.toggleMenu}
            id="css-toggle-menu"
            name="css-toggle-menu"
          />
        );
      }
      let backButton = (<div></div>);
      if (
        (sessionStorage.getItem('masterAcct') &&
          sessionStorage.getItem('masterAcct') !== ('null' || null)) &&
        sessionStorage.getItem('mac') && sessionStorage.getItem('mac') !== ('null' || null)
      ) {
        if (sessionStorage.getItem('masterAcct') === 'MULTIPLE') {
          backButton = (
            <div
              style={{ position: 'relative' }}
              onMouseOver={() => {
                this.setState({
                  showTooltip: !this.state.showTooltip
                });
              }}
              onMouseOut={() => {
                this.setState({
                  showTooltip: false
                });

              }}>
              {this.state.showTooltip &&
                <span className={classes.tooltipclass}>There is no associated master account for this tenant.</span>
              }
              <span

                id="backToPropertyManager"
                style={{
                  display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems:
                    'center', fontWeight: 'bold', color: 'gray', cursor: 'not-allowed'
                }}

              >
                <MdKeyboardArrowLeft aria-label="arrow left" color={'gray'} size={'35px'} />
                Back to Property Manager
              </span>
            </div>
          )
        } else {
          backButton = (
            <div >
              <span

                id="backToPropertyManager"
                style={{
                  cursor: 'pointer', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems:
                    'center', fontWeight: 'bold', color: '#0073d1'
                }}
                onClick={() => {
                  this.props.onInitStartApp(sessionStorage.getItem('masterAcct'))
                }}
              >
                <MdKeyboardArrowLeft aria-label="arrow left" color={'gray'} size={'35px'} />
                Back to Property Manager
              </span>
            </div>
          )
        }
      }
      let leftPanelHtml = (<div className={classes.Sidepanel} >
        {backButton}
        {networkInfo}
        <div className={classes.GraySpacerDiv}>
          <div className={classes.GraySpacer} />
        </div>
        {networkThread}
         {networkThread && <div className={classes.GraySpacerDiv}>
          <div className={classes.GraySpacer} />
        </div>}
        {equipmentComponent}
        {progressBar}
      </div>);

      if (this.state.showSidePanelMobile && !this.state.showing) {

        leftPanelHtml = (<div className={classes.Sidepanel} style={{ display: 'block' }}>
          {backButton}
          {networkInfo}
          <div className={classes.GraySpacerDiv}>
            <div className={classes.GraySpacer} />
          </div>
          {networkThread}
          {networkThread && <div className={classes.GraySpacerDiv}>
            <div className={classes.GraySpacer} />
          </div>}
          {equipmentComponent}
          {progressBar}
        </div>);
      }

      sideDrawerComponent = (
        <Box>

          {toggleInput}
          {leftPanelHtml}
          <div className={classes.GraySpacerDiv} />
          {!this.props.isDummy && <span
            onClick={() => {
              this.TrippleClick();
            }}
          >
            v{packageJson.version}
          </span>}
          {this.props.isDummy &&
            <span>
              <div
                onClick={() => {
                  this.TrippleClick();
                }}
              >
                UI: v{packageJson.version}
              </div>
              <div>
                server: v{this.props.winVersions.server}
              </div>
              <div>
                platform: v{this.props.winVersions.platform}
              </div>
            </span>}

          {toggleMenu}
        </Box>
      );
    }


    let innerToolBarWithRoutes;

    innerToolBarWithRoutes = (
      <React.Fragment>
        <InnerToolBar
          selectedEquipment={this.props.selectedEquipment}
          realWan={this.props.realWan}
          changeEquipmentName={this.props.changeEquipmentName}
          error={this.props.error}
          onInitEquipment={this.props.onInitEquipment}
          success={this.props.success}
          locatePodDisplayLED={this.props.locatePodDisplayLED}
          setLocatePod={this.props.setLocatePod}
          realEquipment={this.props.realEquipment}
          wan={this.props.wan}
          checkingWan={this.props.checkingWan}
          podTimer={this.props.podTimer}
          realSettings={this.props.realSettings}
          // wifiSecurity_5ghz={this.props.realSettings["5ghz_wifi"]?.subscriber.security_mode || undefined}
          // wifiSecurity_6ghz={this.props.realSettings["6ghz_wifi"]?.subscriber.security_mode || undefined}
        />
        {this.props.routes}
      </React.Fragment>
    );
    let leftPanelSideDrawer = (<div className={classes.SideDrawer}>{sideDrawerComponent}</div>);
    if (this.state.showSidePanelMobile && !this.state.showing) {
      leftPanelSideDrawer = (<div className={classes.SideDrawer} style={{ display: 'block' }}>{sideDrawerComponent}</div>);
    }
    
    return (
      <Box>
        <main>
          <Toolbar
            showLogo={this.state.showing}
            isAuth={this.props.isAuthenticated}
            userId={this.props.loggedinUserId}
          />

          <div className={classes.Page}>
            {leftPanelSideDrawer}

            <div ref="innerContainer" className={classes.InnerContainer}>
              {innerToolBarWithRoutes}

            </div>

          </div>
        </main>
        <Modal show={this.state.modal} modalClosed={this.modalCancelHandler}>
          <SwitchAccountsForm
            resetEquipmentErrorSuccess={this.props.onResetEquipmentErrorSuccess}
            loading={this.props.equipmentLoading}
            modalCancel={this.modalCancelHandler}
          />
        </Modal>
        <Modal
          show={this.state.error}
          modalClosed={this.successErrorResetHandler}
        >
          <Error id={'LayoutError'} />
        </Modal>
        <Modal
          show={this.state.success}
          modalClosed={this.successErrorResetHandler}
        >
          <Success id={'LayoutSuccess'} />
        </Modal>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    isPinxt: state.auth.pToken !== null,
    loggedinUserId: sessionStorage.getItem('userId'),
    account: state.settings.account,
    realSettings: state.settings.realSettings,
    settingsLoading: state.settings.loading,
    settingsLoaded: state.settings.loaded,
    wanLoading: state.wan.loading,
    wanLoaded: state.wan.loaded,
    chageLog: state.changeLog,
    realWan: state.wan.realWan,
    wan: state.wan,
    checkingWan: state.wan.checkingWan,
    podTimer: state.wan.podTimer,
    showTimeRemaining: state.settings.showTimeRemaining,
    success: state.equipment.success,
    error: state.equipment.error,
    equipmentLoading: state.equipment.loading,
    equipmentLoaded: state.equipment.loaded,
    realEquipment: state.equipment.realEquipment,
    selectedEquipment: state.equipment.selectedEquipment,
    showSideMenu: state.spectrumReady.showSideMenu,
    locatePodDisplayLED: state.equipment.locatePodDisplayLED,
    isDummy: state.auth.isDummy,
    winVersions: state.settings.versions,
    threadInitialLoadFailed: state.networkThread.threadInitialLoadFailed
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onInitDns: () => dispatch(actions.initDns()),
    onInitWan: () => dispatch(actions.initWan()),
    onInitDhcp: () => dispatch(actions.initDhcp()),
    onInitUpnp: () => dispatch(actions.initUpnp()),
    onInitLogs: () => dispatch(actions.initLogs()),
    onInitTenant: () => dispatch(actions.getPropertyManagerDetails(true)),
    setLocatePod: (payload) => { dispatch(actions.setLocatePod(payload)) },
    locateAllPods: () => { dispatch(actions.locateAllPods()) },
    onInitManaged: () => dispatch(actions.initManaged()),
    onInitDevices: () => dispatch(actions.initDevices()),
    onInitStartApp: (masterAcct) => dispatch(actions.startAppSaga(masterAcct)),
    getEntitlement: () => dispatch(actions.getEntitlement()),
    onInitSettings: () => dispatch(actions.initSettings()),
    onInitBandwidth: () => dispatch(actions.initBandwidth()),
    onToggleIsDummy: () => dispatch(actions.toggleIsDummy()),
    getMultiRouter: () => dispatch(actions.getMultiRouter()),
    onResetEquipmentErrorSuccess: () =>
      dispatch(actions.resetEquipmentErrorSuccess()),
    onInitSelectedEquipment: () => dispatch(actions.initSelectedEquipment()),
    onSetSelectedEquipment: (equipment) => {
      dispatch(actions.setSelectedEquipment(equipment));
    },
    changeEquipmentName: (payload) =>
      dispatch(actions.changeEquipmentName(payload)),
    onInitEquipment: () => {
      dispatch(actions.initEquipment());
    },
    onGetFirmwareUpdate: () => dispatch(actions.getFirmwareUpdate(true)),
    onInitEquipment: () => { dispatch(actions.initEquipment()) },
    onInitMobileHome: () => dispatch(actions.initMobileHome()),
    onDontShowSideMenu: () => dispatch(actions.dontShowSideMenu()),
    onInitDeviceGroups: () => dispatch(actions.initDeviceGroups()),
    changeEquipmentName: (payload) => dispatch(actions.changeEquipmentName(payload)),
    onGetFirmwareUpdate: () => dispatch(actions.getFirmwareUpdate(true)),
    onInitSecurityLogInfo: () => dispatch(actions.initSecurityLogInfo()),
    onSetSelectedEquipment: (equipment) => { dispatch(actions.setSelectedEquipment(equipment)) },
    onInitSelectedEquipment: () => dispatch(actions.initSelectedEquipment()),
    onAdvancedSecurityHandler: (payload) => dispatch(actions.advancedSecurityHandler(payload)),
    getSpeedBoostCheckDevices: () => { dispatch(actions.getSpeedBoostCheckDevices()) },
    // checkRouterSpeedVisiblity: () => dispatch(actions.checkRouterSpeedVisiblity()),
    setRouterSpeedVisiblity: (payload) => dispatch(actions.setRouterSpeedVisiblity(payload)),
    onGetAdvancedSecurityThreats: (payload) => dispatch(actions.getAdvancedSecurityThreats(payload)),
    onResetEquipmentErrorSuccess: () => dispatch(actions.resetEquipmentErrorSuccess()),
    getSecondSsid: () => dispatch(actions.getSecondSsid()),
    getAllWifiSecuritySummary: () =>dispatch(actions.getAllWifiSecuritySummary()),
    onInitBroadcastSettings: () => dispatch(actions.initBroadcastSettings()),
    onInitStaticIPConfig: () => dispatch(actions.initStaticIPConfig())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);